import React from 'react'

import {
  DailyJobLimitIllustration,
  DuplicateJobIllustration,
} from 'business/direct_quote_request/components/PrePostJobCheckIllustrations'
import { HELP_CENTRE_FAQ_URL } from 'business/direct_quote_request/constants'

const FaqFooter = () => (
  <p className="w-full text-center text-sm font-normal text-base-gray-text-main">
    Need a hand? Visit our{' '}
    <a
      href={HELP_CENTRE_FAQ_URL}
      className="font-normal text-base-link underline hover:opacity-80"
      target="_blank"
      rel="noopener noreferrer"
    >
      FAQs.
    </a>
  </p>
)

const PanelLayout = ({ illustration, title, action = null }) => (
  <div className="flex min-h-0 w-full flex-1 flex-col items-center justify-center gap-4 pb-[100px]">
    {illustration}
    <h3 className="w-full text-center text-lg font-extrabold text-base-gray-text-main">
      {title}
    </h3>
    {action}
    <FaqFooter />
  </div>
)

const PrePostJobCheckPanel = ({
  errorMessage,
  duplicateJobId,
  categoryName,
  suburbName,
}) => {
  let content = null

  if (errorMessage === 'TOO_MANY_JOB_REQUESTS') {
    content = (
      <PanelLayout
        illustration={<DailyJobLimitIllustration />}
        title="You've reached today's job posting limit. Try again tomorrow."
      />
    )
  }

  if (errorMessage === 'DUPLICATE_JOB') {
    content = (
      <PanelLayout
        illustration={<DuplicateJobIllustration />}
        title={`You've already posted a ${categoryName} in ${suburbName}`}
        action={(
          <a
            href={`/jobs/${duplicateJobId}`}
            className="btn-neutral btn-base-large inline-flex shrink-0 items-center gap-1 text-base-gray-text-main"
          >
            <span className="text-base font-medium">View your job</span>
            <hero-icon-solid name="arrow-right" class="h-4 w-4 shrink-0 text-base-gray-text-main" />
          </a>
        )}
      />
    )
  }

  if (!content) {
    return null
  }

  return (
    <div className="dqr-pre-post-job-check flex h-full min-h-0 w-full flex-1 flex-col p-4 md:p-12">
      {content}
    </div>
  )
}

export default PrePostJobCheckPanel
